<div class="toTop"><div class="top"><span class="toTopIcon" @click="goTop()"><font-awesome-icon icon="fa-angle-up"></font-awesome-icon></span></div></div>